<template>
  <div class="container">
    <div class="border mt-4 p-4 rounded" v-if="studio.has_registered_events">
      <div class="row">
        <div
          class="col-12 d-flex flex-row align-items-center justify-content-between"
        >
          <h3 class="m-0">{{ $t('STUDIO.SECTIONS.EVENTS') }}:</h3>
          <router-link
            class="undecorated-router-link"
            :to="{
              name: 'studio-calendar',
            }"
          >
            <HMButton color="outline-gray" class="pull-right">
              {{ $t('EVENTS.BUTTON.VIEW_ALL_EVENTS') }}
            </HMButton>
          </router-link>
        </div>
        <div class="col-12 mt-2">
          <CompactEventsCalendar
            :studioURL="studio.studio_url"
            :isRegistered="true"
          />
        </div>
      </div>
    </div>
    <div class="mt-4" v-else>
      <HMNoDataCard
        :title="$t('STUDIO.TITLE.NO_EVENTS')"
        :description="
          $t('STUDIO.TEXT.THE_STUDIO_CURRENTLY_DOESNT_HAVE_ANY_PLANNED_EVENTS')
        "
        :toLabel="$t('STUDIO.BUTTON.BROWSE_PRODUCTS')"
        toRouteName="studio-shop"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CompactEventsCalendar from '@/web/components/events/CompactEventsCalendar';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'StudentEvents',
  components: {
    CompactEventsCalendar,
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
